export default __webpack_public_path__ + "static/media/DNo.23-1.59bf4e21.jpg";